import { ReactComponent as CloseIcon } from "src/images/tooltip-close-icon.svg";
import { ThemeType } from "src/styles/theme";
import styled, { FlattenSimpleInterpolation } from "styled-components";

export const TooltipArrow = styled.div`
  &,
  &::before {
    position: absolute;
    width: 16px;
    height: 16px;
    background: inherit;
    border: inherit;
  }

  visibility: hidden;

  &::before {
    visibility: visible;
    content: "";
    border-left: none;
    border-bottom: none;
  }
`;
// Fixes syntax highlighting
interface TooltipWrapperProps {
  borderThemeColor: keyof ThemeType["colors"];
  helperStyles?: FlattenSimpleInterpolation;
}

export const TooltipWrapper = styled.div<TooltipWrapperProps>`
  width: 97vw;
  max-width: 400px;
  background: ${({ theme }) => theme.colors.background};
  padding: 24px 56px 16px 16px;
  border-radius: 18px;
  border: 2px solid
    ${({ theme, borderThemeColor }) => theme.colors[borderThemeColor]};

  &[data-placement^="top"] ${TooltipArrow} {
    bottom: -5.5px;

    &::before {
      transform: rotate(135deg);
    }
  }

  &[data-placement^="bottom"] ${TooltipArrow} {
    top: -9.5px;

    &::before {
      transform: rotate(-45deg);
    }
  }

  &[data-placement^="left"] ${TooltipArrow} {
    right: -5.5px;

    &::before {
      transform: rotate(45deg);
    }
  }

  &[data-placement^="right"] ${TooltipArrow} {
    left: -9.5px;

    &::before {
      transform: rotate(-135deg);
    }
  }

  ${({ helperStyles }) => helperStyles}
`;

export const TooltipCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
`;

export const TooltipMessageContent = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.xxxs};
`;

export const TooltipTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fonts.sizes.s};
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  margin-bottom: 16px;

  span {
    margin-left: 12px;
  }
`;
